export default __webpack_public_path__ + "static/media/ico-bookmark-active-sm.48e6264a.svg";